import type { IconProps } from './IconProps';

export const ToastCrossIcon = (props: IconProps) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.29289 3.2426C3.68342 2.85208 4.31658 2.85208 4.70711 3.2426L7.925 6.46049L11.1429 3.2426C11.5334 2.85208 12.1666 2.85208 12.5571 3.2426C12.9476 3.63312 12.9476 4.26629 12.5571 4.65681L9.33921 7.87471L12.5571 11.0926C12.9476 11.4831 12.9476 12.1163 12.5571 12.5068C12.1666 12.8973 11.5334 12.8973 11.1429 12.5068L7.925 9.28892L4.70711 12.5068C4.31658 12.8973 3.68342 12.8973 3.29289 12.5068C2.90237 12.1163 2.90237 11.4831 3.29289 11.0926L6.51079 7.87471L3.29289 4.65681C2.90237 4.26629 2.90237 3.63312 3.29289 3.2426Z"
      fill="white"
    />
  </svg>
);
